<template>
  <CBox>
    <OmtTypography as="p1" mb="24px"> Edite ou adicione suas <b>informações pessoais</b>. </OmtTypography>
    <template v-if="titular">
      <CFlex mb="16px">
        <OmtIcons name="home" height="16px" width="16px" size="lg"
mr="8px" />
        <OmtTypography as="h2-bold" mb="12px">Endereço</OmtTypography>
      </CFlex>
      <OmtCard w="100%" mb="24px">
        <CFlex direction="column" mb="12px">
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">CEP</OmtTypography>
          <OmtInput
            v-model="endereco.cep"
            v-mask="'#####-###'"
            :disabled="existChangeRequest"
            max-size="9"
            fontSize="14px"
            fontWeight="700"
            @change="e => onCepChanged(e)"
          />
        </CFlex>
        <CFlex direction="column" mb="12px">
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Bairro</OmtTypography>
          <OmtInput
            v-model="endereco.bairro"
            :disabled="naoPermiteAdicinarEnderecoCepInvalido"
            fontSize="14px"
            fontWeight="700"
          />
        </CFlex>
        <CFlex direction="column" mb="12px">
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Logradouro</OmtTypography>
          <OmtInput
            v-model="endereco.logradouro"
            :disabled="naoPermiteAdicinarEnderecoCepInvalido"
            fontSize="14px"
            fontWeight="700"
          />
        </CFlex>
        <CFlex direction="column" mb="12px">
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Número</OmtTypography>
          <OmtInput
            v-model="endereco.numero"
            :disabled="existChangeRequest"
            fontSize="14px"
            fontWeight="700"
            max-size="10"
          />
        </CFlex>
        <CFlex direction="column" mb="12px">
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Complemento (opcional)</OmtTypography>
          <OmtInput
            v-model="endereco.complemento"
            :disabled="existChangeRequest"
            fontSize="14px"
            fontWeight="700"
            max-size="40"
          />
        </CFlex>
        <template v-if="naoPermiteAdicinarEnderecoCepInvalido">
          <CFlex direction="column" mb="12px">
            <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Estado</OmtTypography>
            <OmtInput v-model="endereco.uf" is-disabled fontSize="14px" fontWeight="700"
max-size="40" />
          </CFlex>
          <CFlex direction="column" mb="12px">
            <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Cidade</OmtTypography>
            <OmtInput v-model="endereco.cidade" is-disabled fontSize="14px" fontWeight="700"
max-size="40" />
          </CFlex>
        </template>
        <template v-else>
          <CFlex direction="column" mb="12px">
            <OmtTypography as="p1">Estado</OmtTypography>
            <OmtSelect placeholder="Selecione o estado" @change="e => onUfChange(e)">
              <option v-for="(uf, index) in estados" :key="index"
:value="uf">
                {{ uf }}
              </option>
            </OmtSelect>
          </CFlex>
          <CFlex direction="column" mb="12px">
            <OmtTypography as="p1">Cidade</OmtTypography>
            <OmtSelect v-if="isLoadingCidades" placeholder="Selecione a cidade"
is-loading />
            <OmtSelect
              v-else
              placeholder="Selecione a cidade"
              :loading="isLoadingCidades"
              @change="e => onCidadeChange(e)"
            >
              <option v-for="(c, index) in cidades" :key="index"
:value="c.id">
                {{ c.nome }}
              </option>
            </OmtSelect>
          </CFlex>
        </template>
      </OmtCard>
    </template>

    <CFlex mb="16px">
      <OmtIcons name="envelope-open-text" height="16px" width="16px" size="lg"
mr="8px" />
      <OmtTypography as="h2-bold" mb="12px">E-mail</OmtTypography>
    </CFlex>
    <OmtCard w="100%" mb="24px">
      <CFlex direction="column" mb="12px">
        <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">E-mail</OmtTypography>
        <OmtInput
          v-model="$v.email.pessoal.$model"
          :disabled="existChangeRequest"
          max-size="255"
          fontSize="14px"
          fontWeight="700"
        />
      </CFlex>
      <CFlex v-if="email.showFatura" direction="column"
mb="12px">
        <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">E-mail para envio de Fatura</OmtTypography>
        <OmtInput
          v-model="$v.email.fatura.$model"
          :disabled="existChangeRequest"
          max-size="255"
          fontSize="14px"
          fontWeight="700"
        />
      </CFlex>
      <CFlex v-if="email.showFatura" direction="column"
mb="12px">
        <OmtTypography as="p2">Utilizado para envio da sua Fatura Digital</OmtTypography>
      </CFlex>
    </OmtCard>

    <CFlex mb="16px">
      <OmtIcons name="phone" height="16px" width="16px" size="lg"
mr="8px" />
      <OmtTypography as="h2-bold" mb="12px">Telefone</OmtTypography>
      <CFlex>
        <OmtIcons
          name="circle-exclamation"
          height="16px"
          width="16px"
          size="lg"
          ml="16px"
          @mouseleave="showTooltipPhone = false"
          @mouseover="showTooltipPhone = true"
        />
        <CBox
          v-if="showTooltipPhone"
          class="tooltip-phone"
          bg="var(--colors-light-primary-navy-blue)"
          color="var(--colors-white)"
          borderRadius="4px"
        >
          <span>Você pode cadastrar apenas três números de telefone</span>
        </CBox>
      </CFlex>
    </CFlex>
    <OmtCard v-for="(fone, index) in telefones" v-show="!fone.removido" :key="index" w="100%"
mb="24px">
      <CFlex direction="column" mb="12px">
        <CFlex direction="row" justify="space-between"
flex-wrap="wrap">
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Tipo do telefone</OmtTypography>
          <OmtIcons
            v-if="!existChangeRequest"
            name="trash-can"
            height="16px"
            width="16px"
            size="lg"
            ml="16px"
            color="var(--colors-light-primary-navy-blue)"
            cursor="pointer"
            @click.prevent="onRemoverTelefoneClick(index)"
          />
        </CFlex>
        <OmtSelect
          :disabled="existChangeRequest"
          placeholder="Selecione o tipo do telefone"
          :initialValue="fone.tipo"
          @change="e => onTipoTelefoneChange(index, e)"
        >
          <option value="Celular">Celular</option>
          <option value="Comercial">Comercial</option>
          <option value="Residencial">Residencial</option>
        </OmtSelect>
      </CFlex>
      <CFlex direction="column" mb="18px">
        <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">Telefone</OmtTypography>
        <OmtInput
          v-model="fone.numero"
          v-mask="getMascaraTelefone(fone)"
          :disabled="existChangeRequest"
          max-size="255"
          fontSize="14px"
          fontWeight="700"
        />
      </CFlex>
      <CFlex direction="column" mb="12px">
        <OmtCheckbox
          :isDisabled="existChangeRequest || (fone.tipo !== 'Celular' && fone.tipo !== 'Comercial')"
          :is-checked="fone.whatsapp"
          @change="onWhatappClick(index)"
        >
          <OmtTypography as="p2" pl="15px"> Número Whatsapp </OmtTypography>
        </OmtCheckbox>
      </CFlex>
    </OmtCard>

    <FixedButtonRow :useFooter="false" :solidColor="true"
:fixedSize="podeAdicionarTelefone ? '2x' : '1x'">
      <CFlex direction="column" :w="['100%', '308px !important']">
        <OmtButton
          v-if="podeAdicionarTelefone"
          w="100%"
          variant="ghost"
          color="var(--colors-light-primary-navy-blue)"
          @click="onAdicionarTelefoneClick"
        >
          {{ labelAdicionarTelefone }}
        </OmtButton>
        <OmtButton
          :w="['100%', '308px !important']"
          variant="solid"
          :disabled="!canSubmit"
          @click.prevent="onNextClick"
        >
          Continuar
        </OmtButton>
      </CFlex>
    </FixedButtonRow>
  </CBox>
</template>

<script>
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import utils, { maskTelFull, maskTel9DigitRegion } from "@/utils/utils";
import { required, email } from "vuelidate/lib/validators";
import { zeroPad } from "@/utils/formatters";

export default {
  components: { FixedButtonRow },
  data() {
    return {
      endereco: {
        cep: "",
        tipoLogradouro: "",
        idLogradouro: 0,
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        idCidade: "",
        uf: ""
      },
      telefones: [],
      email: {
        pessoal: "",
        fatura: "",
        showFatura: false
      },
      estados: [],
      isLoadingCidades: false,
      cidades: [],
      showTooltipPhone: false
    };
  },
  validations: {
    email: {
      pessoal: {
        required,
        email
      },
      fatura: {
        required,
        email
      }
    }
  },
  created() {
    this.estados = utils.statesFromCountry.map(estado => estado.initials);
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      if (
        !this.resumeContacts?.Endereco &&
        !this.resumeContacts.Telefones?.length &&
        !this.resumeContacts?.Emails?.Pessoal
      ) {
        await Promise.all([this.fetchResumeContacts(), this.validateActiveTicket(), this.validarAtendimentoWhatsApp()]);
      } else {
        await this.validateActiveTicket();
      }
      const values = this.initialValues();
      this.endereco = values.endereco;
      this.email = values.email;
      this.telefones = values.telefones;
      this.$v.$touch();
    } catch (error) {
      this.$toast({
        description: error.message,
        status: "error",
        duration: 10000,
        position: "bottom-right"
      });
    } finally {
      this.$root.$emit("hide-loading");
    }
  },
  computed: {
    ...mapState("saude", ["titular"]),
    ...mapState("myAccount", ["welcomeOnBoardTourAuth"]),
    ...mapState("myContacts", [
      "resumeContacts",
      "existChangeRequest",
      "newAddress",
      "newEmails",
      "newPhones",
      "newWhatsapp"
    ]),
    ...mapState("atendimento", ["WhatsAppAtivo", "NumeroFormatado", "DDD", "DDI"]),
    naoPermiteAdicinarEnderecoCepInvalido() {
      return true;
      // confirmar regra de cep invalido, se vai permitir informar os dados (hoje falta o tipo de logradouro)
      // return this.existChangeRequest || this.endereco.idLogradouro > 0;
    },
    podeAdicionarTelefone() {
      if (this.existChangeRequest) return false;
      return ((this.telefones ?? []).filter(t => !t.removido) ?? []).length < 3;
    },
    labelAdicionarTelefone() {
      return ((this.telefones ?? []).filter(t => !t.removido) ?? []).length
        ? "Adicionar outro número"
        : "Adicionar número";
    },
    whatsapp() {
      if (this.newWhatsapp) return this.newWhatsapp;

      return this.WhatsAppAtivo ? `+${zeroPad(this.DDI || 0)} (${zeroPad(this.DDD || 0)}) ${this.NumeroFormatado}` : "";
    },
    hasValidAddress() {
      if (!this.titular) return true;
      return !!(
        this.endereco.cep &&
        this.endereco.idLogradouro &&
        this.endereco.numero &&
        this.endereco.bairro &&
        this.endereco.cidade &&
        this.endereco.uf
      );
    },
    hasValidEmail() {
      if (!this.email.pessoal || this.$v.email.pessoal.$error) return false;
      if (!this.email.showFatura) return true;
      return !!this.email.fatura && !this.$v.email.fatura.$error;
    },
    canSubmit() {
      return this.hasValidAddress && this.hasValidEmail;
    }
  },
  methods: {
    ...mapActions("myContacts", [
      "createChangeRequestFromTour",
      "fetchResumeContacts",
      "fetchCities",
      "fetchAddressInfos",
      "validateActiveTicket",
      "validadeChanges"
    ]),
    ...mapActions("atendimento", ["validarAtendimentoWhatsApp", "ativarAtendimentoWhatsApp"]),
    ...mapActions("myAccount", ["checkNextWelcomeOnBoardTour"]),
    ...mapMutations("myContacts", ["SET_NEW_STATE"]),
    ...mapMutations("myAccount", ["SET_WELCOME_ONBOARD_TOUR_AUTH_RULES"]),
    initialValues() {
      const baseEndereco = this.newAddress ?? this.resumeContacts?.Endereco;
      const endereco = {
        cep: baseEndereco?.CEP ?? "",
        tipoLogradouro: baseEndereco?.TipoLogradouro ?? "",
        idLogradouro: baseEndereco?.IdLogradouro ?? 0,
        logradouro: baseEndereco?.Logradouro ?? "",
        numero: baseEndereco?.Numero ?? "",
        complemento: baseEndereco?.Complemento ?? "",
        bairro: baseEndereco?.Bairro ?? "",
        cidade: baseEndereco?.Cidade ?? "",
        uf: baseEndereco?.UF ?? ""
      };
      const baseEmail = this.newEmails ?? this.resumeContacts?.Emails;
      const email = {
        pessoal: baseEmail?.Pessoal ?? "",
        fatura: baseEmail?.Fatura ?? "",
        showFatura: this.titular && !(this.resumeContacts?.Empresarial ?? true)
      };
      const whatsapp = this.whatsapp;
      let fones = [];
      const baseTelefone = this.newPhones ?? this.resumeContacts?.Telefones;
      if (baseTelefone?.length) {
        fones = baseTelefone.map(t => {
          const numero = `${t.countryCode} ${t.Numero}`;
          return {
            tipo: t.Tipo,
            numero,
            whatsapp: numero === whatsapp
          };
        });
      }
      if (this.WhatsAppAtivo && !fones.some(t => t.whatsapp))
        fones = [
          {
            numero: whatsapp,
            tipo: "Celular",
            whatsapp: true
          },
          ...fones
        ];
      const telefones = fones.slice(0, 3);
      return {
        endereco,
        email,
        telefones
      };
    },
    async onCepChanged(event) {
      if (!event?.isTrusted) return;

      let cep = (this.endereco.cep ?? "").replaceAll(/\D/g, "");
      if (cep.length === 8 && !cep.includes("-")) {
        const formattedCEP = cep.replaceAll(/\D/g, "");
        const finalCep = formattedCEP.replace(/^(\d{5})(\d{3})$/, "$1-$2");
        this.endereco.cep = finalCep;
        cep = finalCep;
      }
      if (cep.length !== 9 || cep.replaceAll(/\D/g, "").length !== 8 || cep.substring(5, 6) !== "-") return;

      try {
        this.$root.$emit("show-loading");
        const response = await this.fetchAddressInfos({
          cep
        });

        if (response?.length) {
          const end = response[0];
          this.endereco.idLogradouro = end.Codigo;
          this.endereco.logradouro = end.Descricao;
          this.endereco.tipoLogradouro = end.TipoLogradouro.Codigo;
          this.endereco.bairro = end.Bairro;
          this.endereco.idCidade = end.Municipio.Codigo;
          this.endereco.cidade = end.Municipio.Nome;
          this.endereco.uf = end.Municipio.UF;
        } else {
          this.endereco.idLogradouro = 0;
          this.endereco.logradouro = "";
          this.endereco.tipoLogradouro = "";
          this.endereco.bairro = "";
          this.endereco.idCidade = "";
          this.endereco.cidade = "";
          this.endereco.uf = "";

          this.$toast({
            description: "CEP não localizado",
            status: "error",
            duration: 10000,
            position: "bottom-right"
          });
        }
      } catch (error) {
        console.error("Não foi possível as informações de logradouro", error);
      } finally {
        this.$root.$emit("hide-loading");
      }
    },
    async onUfChange(uf) {
      if (!uf) {
        this.onCidadeChange(0);
        return;
      }

      let cidades = [];
      try {
        this.$root.$emit("show-loading");
        this.isLoadingCidades = true;
        this.endereco.cidade = "";
        this.endereco.idCidade = "";
        const response = await this.fetchCities({
          uf
        });
        if (response?.length) {
          cidades = response.map(c => ({
            id: `${c.Id}`,
            nome: c.Nome
          }));
        }
      } catch (error) {
        console.error("Não foi possível obter a lista de cidades", error);
      } finally {
        this.isLoadingCidades = false;
        this.$root.$emit("hide-loading");
      }

      this.cidades = cidades;
    },
    onCidadeChange(cidade) {
      if (cidade) {
        this.endereco.idCidade = cidade;
        this.endereco.cidade = this.cidades.find(c => c.id === cidade).nome;
      } else {
        this.endereco.cidade = "";
        this.endereco.idCidade = "";
      }
    },
    onAdicionarTelefoneClick() {
      if (this.existChangeRequest) return;
      if (!this.podeAdicionarTelefone) return;
      this.telefones.push({ tipo: "Celular", numero: "+55", whatsapp: false });
      this.$nextTick(() => globalThis.window.scrollTo(0, document.body.scrollHeight));
    },
    getMascaraTelefone(fone) {
      if (fone.tipo === "Comercial" || fone.tipo === "Residencial") {
        return maskTelFull(fone.numero);
      } else {
        return maskTel9DigitRegion;
      }
    },
    onRemoverTelefoneClick(indexRemovido) {
      if (this.existChangeRequest) return;
      const telefones = [];
      this.telefones.forEach((t, index) => {
        const fone = { ...t };
        if (index === indexRemovido) {
          fone.removido = true;
        }
        telefones.push(fone);
      });
      this.telefones = telefones;
    },
    onTipoTelefoneChange(indexAlterado, tipo) {
      if (this.existChangeRequest) return;
      const telefones = [];
      this.telefones.forEach((t, index) => {
        const fone = { ...t };
        if (index === indexAlterado) {
          fone.tipo = tipo;
          if (tipo !== "Celular" && tipo !== "Comercial") fone.whatsapp = false;
        }
        telefones.push(fone);
      });
      this.telefones = telefones;
    },
    onWhatappClick(indexMarcado) {
      if (this.existChangeRequest) return;
      this.telefones.forEach(
        (t, index) =>
          (t.whatsapp = !t.whatsapp && index === indexMarcado && (t.tipo === "Celular" || t.tipo === "Comercial"))
      );
    },
    buildPhonesPayload() {
      const countryCodeRegex = /^\+(\d+)\s*/;
      return this.telefones
        .filter(tel => !tel.removido)
        .map(tel => {
          const match = tel.numero.match(countryCodeRegex);
          const countryCode = match && match[1] ? "+" + match[1] : "";
          return {
            Numero: tel.numero.replace(countryCodeRegex, ""),
            Tipo: tel.tipo,
            countryCode
          };
        });
    },
    setContactDrafts() {
      this.SET_NEW_STATE({ key: "newPhones", value: this.buildPhonesPayload() });
      this.SET_NEW_STATE({
        key: "newEmails",
        value: {
          Pessoal: this.email.pessoal,
          Fatura: this.email.fatura
        }
      });
      this.SET_NEW_STATE({
        key: "newAddress",
        value: {
          CEP: this.endereco.cep,
          TipoLogradouro: this.endereco.tipoLogradouro,
          IdLogradouro: this.endereco.idLogradouro,
          Logradouro: this.endereco.logradouro,
          Numero: this.endereco.numero,
          Complemento: this.endereco.complemento,
          Bairro: this.endereco.bairro,
          Cidade: this.endereco.cidade,
          UF: this.endereco.uf
        }
      });
    },
    clearUnchangedDrafts(validacaoAlteracao) {
      if (!validacaoAlteracao?.Enderecos?.length) this.SET_NEW_STATE({ key: "newAddress", value: null });
      if (!validacaoAlteracao?.Emails?.length) this.SET_NEW_STATE({ key: "newEmails", value: null });
      if (!validacaoAlteracao?.Telefones?.length) this.SET_NEW_STATE({ key: "newPhones", value: null });
    },
    async continueAfterValidation(semAlteracaoContatos, semAlteracaoWhatsapp, whatsappSelecionado) {
      if (semAlteracaoContatos) {
        if (!semAlteracaoWhatsapp) {
          await this.ativarAtendimentoWhatsApp({
            phoneNumber: whatsappSelecionado,
            auth: 0
          });
        }
        this.nextTask();
        return;
      }
      if (this.welcomeOnBoardTourAuth) {
        this.submit();
        return;
      }
      this.SET_WELCOME_ONBOARD_TOUR_AUTH_RULES({
        routeBack: this.$route.path,
        action: "myContacts/createChangeRequestFromTour"
      });
      this.$router.push("/welcome/identity-verification");
    },
    async onNextClick() {
      try {
        this.$root.$emit("show-loading");
        let semAlteracaoWhatsapp = true;
        let semAlteracaoContatos = true;
        let whatsappSelecionado = "";
        if (!this.existChangeRequest) {
          this.setContactDrafts();
          const validacaoAlteracao = await this.validadeChanges({ allowWithoutChanges: true });
          const whatsappAtual = this.whatsapp;
          whatsappSelecionado = this.telefones.find(t => !!t.whatsapp)?.numero ?? "";
          if (!whatsappSelecionado || whatsappSelecionado === whatsappAtual) {
            whatsappSelecionado = null;
          }
          this.SET_NEW_STATE({ key: "newWhatsapp", value: whatsappSelecionado });
          if (validacaoAlteracao?.MsgValidacao) {
            // erro nos dados
            this.$toast({
              description: validacaoAlteracao.MsgValidacao,
              status: "error",
              duration: 10000,
              position: "bottom-right"
            });
            return;
          }
          semAlteracaoWhatsapp = !whatsappSelecionado;
          semAlteracaoContatos =
            !validacaoAlteracao?.Enderecos?.length &&
            !validacaoAlteracao?.Emails?.length &&
            !validacaoAlteracao?.Telefones?.length;
          this.clearUnchangedDrafts(validacaoAlteracao);
        }
        await this.continueAfterValidation(semAlteracaoContatos, semAlteracaoWhatsapp, whatsappSelecionado);
      } catch (error) {
        this.$toast({
          description: error.message,
          status: "error",
          duration: 10000,
          position: "bottom-right"
        });
      } finally {
        this.$root.$emit("hide-loading");
      }
    },
    async nextTask() {
      const rota = await this.checkNextWelcomeOnBoardTour();
      this.$router.replace(rota);
    },
    async submit() {
      try {
        this.$root.$emit("show-loading");
        await this.createChangeRequestFromTour();
        this.nextTask();
      } catch (error) {
        this.$toast({
          description: error.message,
          status: "error",
          duration: 10000,
          position: "bottom-right"
        });
      } finally {
        this.$root.$emit("hide-loading");
      }
    }
  }
};
</script>
<style scoped lang="scss">
.tooltip-phone {
  position: absolute;
  width: 200px;
  transform: translate(50px, -12px);
  padding: 2px 4px;
  font-size: 12px;
  text-align: center;
}
.tooltip-phone::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  width: 16px;
  height: 8px;
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent #172972 transparent transparent;
}
</style>
